<template>
  <div class="user-list">
    <v-card :loading="isLoading">
      <template v-if="user && room">
        <v-card-title>
          {{ user.name }}
        </v-card-title>
        <v-card-text>
          <div class="body-1">
            E-mail: <a :href="`mailto:${user.email}`">{{ user.email }}</a>
          </div>
          <div class="body-1">
            Téléphone: <a :href="`tel:${user.phone}`">{{ user.phone }}</a>
          </div>
          <div class="body-1">
            Né le: {{ user.birthDate}}
          </div>
          <div class="body-1">
            Nationalité: {{ user.nationality}}
          </div>
          <br>
          <div class="body-1">
            Le client <b>{{ reservationText(user.status) }} </b> la chambre
            <router-link :to="`/rooms/${room.id}`">{{ room.name }}</router-link>
          </div>
        </v-card-text>
      </template>
    </v-card>
  </div>
</template>

<script>

import api from '@/plugins/APIWrapper';
import { reservationMixins } from '@/mixins';

export default {
  name: 'user-details',
  mixins: [reservationMixins],
  data() {
    return {
      user: null,
      room: null,
      isLoading: 'success',
    };
  },
  components: {},
  async mounted() {
    try {
      this.user = await api.getClient(this.$route.params.id);
      this.room = await api.getRoom(this.user.roomId);
      this.isLoading = false;
    } catch (e) {
      console.error(e);
      this.isLoading = 'error';
    }
  },
};
</script>
